import { RootState } from '..';

export const getShop = (state: RootState, { shopId }: { shopId: string }) =>
  state.shops[shopId];
